import React from 'react'
import { Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

const PublicRoute = ({ children = {} }) => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn)

  return (
    <>
      {(isLoggedIn) ? (
        <Navigate to='/dashboard' />
      ) : (
        children
      )}
    </>
  )
}

export default PublicRoute
